module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column h-100 position-relative"
  }, [_c('div', {
    staticClass: "navigator",
    staticStyle: {
      "height": "65px"
    }
  }, [_c('h2', {
    staticClass: "mr-auto"
  }, [_vm._v("Schedule Tasks")]), _vm._v(" "), _c('button', {
    staticClass: "btn wide",
    on: {
      "click": _vm.createNew
    }
  }, [_c('i', {
    staticClass: "ico-add large"
  }), _vm._v("\n            Create New\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto flexGrow1"
  }, [_c('div', {
    staticClass: "px-3 py-4 d-flex"
  }, [_c('div', {
    staticClass: "col-sm-12 bg-lightest"
  }, [(_vm.isLoadingTable) ? _c('div', {
    staticClass: "p-4 text-center mb-4"
  }, [_c('loader')], 1) : (_vm.getScheduledTasks.length == 0) ? _c('div', {
    staticClass: "text-center dark p-4 my-4"
  }, [_c('span', {}, [_vm._v("📎 You have no scheduled tasks yet. "), _c('span', {
    staticClass: "bold underlined pointer",
    on: {
      "click": _vm.createNew
    }
  }, [_vm._v("Create one here")]), _vm._v(".")])]) : _c('div', [_c('div', {
    staticClass: "d-flex justify-content-end my-4"
  }, [(_vm.currentPagination.numPages > 1) ? _c('uib-pagination', {
    attrs: {
      "total-items": _vm.paginationSettings.totalItems,
      "items-per-page": _vm.paginationSettings.itemsPerPage,
      "boundary-link-numbers": false,
      "max-size": 7
    },
    on: {
      "change": _vm.fetchItems
    },
    model: {
      value: (_vm.currentPagination),
      callback: function($$v) {
        _vm.currentPagination = $$v
      },
      expression: "currentPagination"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('list', {
    attrs: {
      "header": _vm.header,
      "body": _vm.body,
      "rows": _vm.tableRows,
      "actions": _vm.actions,
      "showNoDataMessage": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end my-4"
  }, [(_vm.currentPagination.numPages > 1) ? _c('uib-pagination', {
    attrs: {
      "total-items": _vm.paginationSettings.totalItems,
      "items-per-page": _vm.paginationSettings.itemsPerPage,
      "boundary-link-numbers": false,
      "max-size": 7
    },
    on: {
      "change": _vm.fetchItems
    },
    model: {
      value: (_vm.currentPagination),
      callback: function($$v) {
        _vm.currentPagination = $$v
      },
      expression: "currentPagination"
    }
  }) : _vm._e()], 1)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2757ba39"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/scheduleTasks/scheduleTasks.vue
// module id = 2692
// module chunks = 0